module.exports = new __parcel__URL__("balloons-darkmode.7d1967f8.svg").toString();